import Main from "../top/intro/main.es6";
import Mmovie from "../top/m-movie.es6";

export default class Loading {
    constructor() {
        this.intro = new Main();
        this.movie = new Mmovie();

        this.init();
    }

    init() {
        this.skipLoading();
    }

    skipLoading() {
        if (STORAGE.data.intro) {
            this.setThema();
            this.LoadingIn();

            this.intro._init();

            //遷移時動画再生OFF
            /* setTimeout(() => {
                const top = document.querySelector(".top");
                const videoID = top.getAttribute("data-videoID");
                this.movie.init(videoID);
            }, 6000); */
        } else {
            //イントロ非表示
            this.hideLoading();

            //遷移時動画再生OFF
            /* setTimeout(() => {
                const top = document.querySelector(".top");
                const videoID = top.getAttribute("data-videoID");
                this.movie.init(videoID);
            }, 2500); */
        }
    }

    LoadingIn() {
        const $main = document.getElementById("js-main");
        const $canvas = document.querySelector(".js-canvas");

        window.addEventListener("load", () => {
            $main.classList.add("-loading");

            setTimeout(() => {
                $main.classList.add("-animation");

                document.body.classList.remove("-loadingout");
            }, 2000);

            setTimeout(() => {
                $main.classList.add("-introend");
                STORAGE.set("isRaf", false);
            }, 5000);

            //イントロ確認する時はコメントアウト
            STORAGE.data.intro && STORAGE.set("intro", false);
        });
    }

    setThema() {
        const thema = ["makyou", "tengoku"];
        let themaClass =
            thema[Math.floor(Math.random() * thema.length)];

        STORAGE.set("ThemaColor", themaClass);
        document.body.classList.add("-" + themaClass);
    }

    hideLoading() {
        const $main = document.getElementById("js-main");

        $main.classList.add("-animation");
        $main.classList.add("-introend");
        document.body.classList.add("-nointro");
        document.body.classList.remove("-loadingout");
        

        window.addEventListener("load", () => {
            $main.classList.add("-loading");
            
        });
    }
}
